import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { Drawer } from "../../components/Drawer";
import { Button } from "../../components/Button";
import { CatalogAPI } from "../../../providers/CatalogAPI";
import { TextFileReaderIfood } from "../../components/TextFileReaderIfood";
import { Message } from "../../components/Message";
import { Label } from "../../components/Label";
import { Context } from "pages/Integrations";
import { Select } from "@components";

const CatalogServices = {
  DELIVERY: {
    key: "DELIVERY",
    name: "Delivery",
  },
  INDOOR: {
    key: "INDOOR",
    name: "Indoor",
  },
};

export default class CatalogNetLogicDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      destination: CatalogServices.INDOOR.key,
    };
  }

  setFile(file) {
    try {
      JSON.parse(file.content);
    } catch (err) {
      alert({
        text: `Arquivo ${file.name} inválido - ${err.message}`,
        buttonText: "Ok",
      });
    }

    this.setState({
      file: file,
    });
  }

  isValid() {
    const { file, destination } = this.state;
    return file?.content && destination;
  }

  async save() {
    const confirmed = await window.confirm({
      text: "Deseja realmente importar o cardápio? Isso sobrescreverá o cardápio atual e não poderá ser desfeito.",
      confirmText: "Importar",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      return;
    }

    this.setState({ loading: true });

    const { file, destination } = this.state;
    const catalog = JSON.parse(file.content);

    const updateResponse = await CatalogAPI.importNetLogicCatalog({
      service: destination,
      catalog,
    });

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    } else {
      alert({ text: "Cárdapio importado!", buttonText: "Ok" });
    }

    this.setState({ loading: false });

    return true;
  }

  render() {
    const { loading, file, destination } = this.state;
    const { visible, onClose } = this.props;

    const isValid = this.isValid();

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Importar um cardápio da NetLogic"
      >
        <Context />

        <div className={styles.scrollContainer}>
          <Message className="w-100 mb-20">
            Produtos cujo preço não foi importado serão ocultos automaticamente.
          </Message>
          <Select
            design="two"
            label="Destino"
            onChange={(e) => this.setState({ destination: e.target.value })}
            className="mb-20"
            value={destination}
            options={Object.values(CatalogServices).map((service) => ({
              label: `Cardápio ${service.name}`,
              value: service.key,
              selected: service.key === destination,
            }))}
          />

          <Label>Cardápio (somente arquivo JSON)</Label>

          {file && (
            <Message type="default" className="mb-10">
              {file.name}
            </Message>
          )}

          <TextFileReaderIfood
            onFileLoaded={(file) => this.setFile(file)}
            allowedFiles={"application/json"}
          />

          <div className={styles.footer}>
            <Button
              design="primary"
              className="w-100"
              onClick={() => this.save()}
              loading={loading}
              disabled={loading || !isValid}
            >
              Importar
            </Button>
          </div>
        </div>
      </Drawer>
    );
  }
}
